import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { styled } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import React from 'react';
import { SHADOW } from 'styles/theme';

import { NavigationDirection } from './types';

type ScrollButtonProps = {
    direction: NavigationDirection;
    handleNavigation: (direction: NavigationDirection) => void;
    idPrefix?: string;
    onClick?: () => void;
};

const getIcon = (direction: NavigationDirection): JSX.Element => {
    switch (direction) {
        case 'left':
            return <KeyboardArrowLeftIcon />;
        case 'right':
            return <KeyboardArrowRightIcon />;
        case 'up':
            return <KeyboardArrowUpIcon />;
        case 'down':
            return <KeyboardArrowDownIcon />;
        default:
            return <></>;
    }
};

const getPositionStyles = (direction: NavigationDirection) => {
    switch (direction) {
        case 'left':
            return { top: '50%', left: '2%', transform: 'translateY(-50%)' };
        case 'right':
            return {
                top: '50%',
                left: '98%',
                transform: 'translate(-100%, -50%)',
            };
        case 'up':
            return { left: '50%', top: '2%', transform: 'translateX(-50%)' };
        case 'down':
            return {
                left: '50%',
                top: '98%',
                transform: 'translate(-50%, -100%)',
            };
        default:
            return {};
    }
};

const StyButton = styled(IconButton, {
    shouldForwardProp: (prop) => prop !== 'direction',
})<{ direction: NavigationDirection }>(({ direction, theme }) => ({
    backgroundColor: 'white',
    '&:hover': {
        backgroundColor: 'white',
        boxShadow: SHADOW,
    },
    border: `0.5px solid ${theme.palette.primary.background}`,
    borderRadius: '50%',
    position: 'absolute',
    ...getPositionStyles(direction),
    zIndex: 9,
}));

const ScrollButton = ({
    direction,
    handleNavigation,
    idPrefix = undefined,
    onClick = () => {},
}: ScrollButtonProps): JSX.Element => {
    const handleClick = () => {
        handleNavigation(direction);
        onClick();
    };

    const scrollButtonId = idPrefix
        ? `${idPrefix}-scroll-${direction}`
        : `scroll-${direction}`;

    return (
        <StyButton
            color="primary"
            direction={direction}
            onClick={handleClick}
            id={scrollButtonId}
        >
            {getIcon(direction)}
        </StyButton>
    );
};

export default ScrollButton;
